import Image from 'next/image'
import { type FC } from 'react'

import { Button } from '@wartek-id/button-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

import type { TabFilterRoles } from 'types/kinerja-ks'

type DialogDeliveryFailedProps = Omit<DialogProps, 'children'> & {
  errorType?: 'ALL' | TabFilterRoles
  onClick: () => void
}

const DialogDeliveryFailed: FC<DialogDeliveryFailedProps> = ({
  errorType = 'ALL',
  onClick = () => {},
  ...props
}) => {
  return (
    <Dialog {...props}>
      <DialogOverlay />
      <DialogContent className="!rounded-lg">
        <div className="p-6">
          <Image
            alt=""
            src="/illustrations/img-warning.png"
            width={84}
            height={84}
          />
          <Text variant="display-sm" className="mt-4">
            {errorType === 'KS' && <>Data Kepala Sekolah gagal dikirim</>}
            {errorType === 'GURU' && <>Data Guru gagal dikirim</>}
            {errorType === 'ALL' && <>Data gagal dikirim</>}
          </Text>

          <Text variant="body-lg" color="subdued" className="mt-2">
            Mohon coba lagi.
          </Text>

          <div className="flex gap-5 mt-6">
            <Button
              size="lg"
              className="w-[159px]"
              data-testid="btn-confirm"
              onClick={onClick}
            >
              Coba lagi
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
export default DialogDeliveryFailed
